import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/views/newtheme/newhome/homeview.vue";
import localForage from "localforage";
import i18n from "@/i18n";
import {
  consumeRedirectUrl,
  getRedirectUrl,
  hasAuthBootstrapQuery,
  hasNosugarSessionFlag,
  isGoogleAuthPending,
  getQueryWithoutAuthBootstrap,
  restoreAuthDataFromRouteQuery,
  saveRedirectUrl,
  setNosugarSessionFlag,
} from "@/utils/storageHelper.js";
import { decodeNosugarPath, isNosugarBrowser } from "@/utils/nosugar.js";
import { getUser } from "@/aips/userManage";

// import Login from "@/views/Login/Login.vue";
import Login from "@/views/newtheme/newLogin/Login.vue";
import BrowserLogin from "@/views/newtheme/newLogin/BrowserLogin.vue";
import SsoAuthorize from "@/views/newtheme/newLogin/SsoAuthorize.vue";
import Analysis from "@/views/newtheme/newhome/homepage.vue";
// import CustomDialog from '../components/MessageBox.vue'
Vue.use(VueRouter);

function buildRouteFromNosugarPath(pathValue) {
  if (!pathValue || typeof pathValue !== "string") {
    return null;
  }

  const decodedPath = decodeNosugarPath(pathValue);
  if (!decodedPath) {
    return null;
  }

  const normalizedPath = decodedPath.startsWith("/")
    ? decodedPath
    : `/${decodedPath}`;
  const [path, queryString = ""] = normalizedPath.split("?");
  const route = { path };

  if (queryString) {
    const params = new URLSearchParams(queryString);
    const query = {};
    params.forEach((value, key) => {
      query[key] = value;
    });
    route.query = query;
  }

  return route;
}

function resolveBrowserLoginTargetRoute(to) {
  return buildRouteFromNosugarPath(to.query.path) || getRedirectUrl();
}

function redirectAfterBrowserLogin(to, next) {
  const targetRoute = resolveBrowserLoginTargetRoute(to);
  consumeRedirectUrl();

  if (targetRoute) {
    // 避免重复跳转到当前路由
    if (to.path === targetRoute.path) {
      next();
      return;
    }
    next({ ...targetRoute, replace: true });
    return;
  }

  // 避免重复跳转到 /home
  if (to.path === "/home") {
    next();
    return;
  }

  next({ path: "/home", replace: true });
}

function consumeRechargeReturnRoute() {
  const params = new URLSearchParams(window.location.search);
  const returnMode = params.get("rechargeReturn");
  if (returnMode !== "records" && returnMode !== "embed") return null;

  // 支付平台可能丢弃 hash，因此使用普通查询参数承接回跳。
  // 识别后清掉支付宝附带的全部查询参数，最终地址只保留站内 hash 路由。
  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname}${window.location.hash}`,
  );
  if (returnMode === "embed") {
    return { path: "/embed/recharge/return" };
  }
  return { path: "/personalinfo", query: { action: "records" } };
}

// Vue.component('custom-dialog', CustomDialog);

//异步
const Adjustment = () => import("@/views/newtheme/Adjustment/Adjustment.vue");
const Largescreen = () =>
  import("@/views/newtheme/Largescreen/Largescreenpage.vue");
// const Adjustment = () => import("@/views/Adjustment/Adjustment.vue");
// const Datacase = () => import("@/views/Datacase/DataCase.vue");
const Datacase = () => import("@/views/newtheme/newDatacase/DataCase.vue");
const Help = () => import("../views/newtheme/newHelp/Help.vue");
const API = () => import("@/views/newtheme/landing/Api.vue");
const Permissions = () => import("../views/Permissions/Permissions.vue");
const Toolpage = () => import("../views/newtheme/toolpage/toolpage.vue");

const canvasshare = () => import("@/views/Analysis/canvas/share/canvasShare");
const AIcanvas = () => import("@/views/AIcanvas/index.vue");
const UserDetailRouteEntry = () =>
  import(
    "@/views/newtheme/details/userDetailsRefactor/UserDetailRouteEntry.vue"
  );

function createUserDetailRoute({
  path,
  name,
  title = "用户详情",
  preferredDetailMode = "exchange",
}) {
  return {
    path,
    name,
    component: UserDetailRouteEntry,
    meta: {
      title1: "研判分析",
      title,
      showHeader: true,
      showfooter: false,
      preferredDetailMode,
    },
  };
}

const routes = [
  {
    path: "/",
    redirect: "/home",
    name: "",
    component: Layout,
    meta: {
      title: "首页",
      showHeader: true,
      showfooter: true,
    },
    children: [
      {
        path: "/home",
        name: "Analysis",
        component: Analysis,
        meta: {
          title: "首页",
          showHeader: true,
          showfooter: true,
        },
        children: [
          {
            path: "/home/addressMonitor",
            name: "AddressMonitor",
            component: () =>
              import("@/views/newtheme/newMonitor/monitorpage.vue"),
            meta: {
              title1: "研判分析",
              title: "地址监控",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/home/remarkManagement",
            name: "RemarkManagement",
            component: () =>
              import(
                "@/views/newtheme/remarkManagement/RemarkManagementPage.vue"
              ),
            meta: {
              title1: "研判分析",
              title: "备注管理",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/home/monitordetail",
            name: "Monitordetail",
            component: () =>
              import("@/views/newtheme/newMonitor/monitordetail.vue"),
            meta: {
              title1: "地址监控",
              title: "监控详情",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/home/transactiondetails/:id",
            name: "transactiondetails",
            component: () =>
              import(
                "@/views/newtheme/details/hashDetailsRefactor/hashDetailMain.vue"
              ),
            meta: {
              title1: "研判分析",
              title: "交易详情",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/home/addressdetail/:id",
            name: "addressdetail",
            component: () =>
              import("@/views/newtheme/details/addressDetailNew/index.vue"),
            meta: {
              title1: "研判分析",
              title: "地址详情",
              showHeader: true,
              showfooter: true,
            },
          },

          // 案件分析
          {
            path: "/home/caseAnalysis",
            name: "CaseAnalysis",
            component: () =>
              import("@/views/newtheme/newcase/Caseanalysis.vue"),
            meta: {
              title1: "研判分析",
              title: "案件分析",
              showHeader: true,
              showfooter: true,
            },
            children: [
              {
                path: "/caseAnalysis/canvaslist",
                name: "Canvaslist",
                component: () =>
                  import("@/views/newtheme/newcase/Canvascontent"),
                meta: {
                  title1: "案件分析",
                  title: "案件画布列表",
                  showHeader: true,
                  showfooter: true,
                },
                children: [
                  // {
                  //   path: "/canvaslist/canvas",
                  //   name: "Canvas",
                  //   component: () => import("@/views/Analysis/canvas/Canvas"),
                  //   meta: {
                  //     title1: "案件画布列表",
                  //     title: "画布",
                  //     showHeader: true,
                  // showfooter: true,
                  //   },
                  // },
                  {
                    path: "/canvaslist/newcanvas",
                    name: "Canvas",
                    component: () =>
                      import("@/views/Analysis/canvas/newCanvas"),
                    // 第三方网站直接跳入临时画布（temporarilycanvas=true）时不经过首页，
                    // 首页菜单组件（Mymenu/homeheader 等）的 getUser() 不会执行，
                    // 导致 localStorage.condition / User / currencySelection 缺失，
                    // newCanvas created() 里 JSON.parse(localStorage.condition) 会直接抛错。
                    // 这里在进入前主动调 getUser() 补齐这三份存储。
                    beforeEnter: (to, from, next) => {
                      if (
                        to.query.temporarilycanvas &&
                        !window.localStorage.getItem("condition")
                      ) {
                        getUser()
                          .then((res) => {
                            if (res && res.data) {
                              window.localStorage.User = JSON.stringify(
                                res.data,
                              );
                              if (res.data.condition !== undefined) {
                                window.localStorage.condition = JSON.stringify(
                                  res.data.condition,
                                );
                              }
                              if (res.data.currencySelection !== undefined) {
                                window.localStorage.currencySelection =
                                  JSON.stringify(res.data.currencySelection);
                              }
                            }
                          })
                          .catch((e) => {
                            console.error(
                              "[路由守卫] 第三方临时画布补用户信息失败：",
                              e,
                            );
                          })
                          .finally(() => {
                            // 无论成败都放行，newCanvas 里还有兜底空结构
                            next();
                          });
                      } else {
                        next();
                      }
                    },
                    meta: {
                      title1: "案件画布列表",
                      title: "画布",
                      showHeader: false,
                      showfooter: false,
                    },
                  },
                  {
                    path: "/canvaslist/demosurveyinfo",
                    name: "Demosurveyinfo",
                    component: () =>
                      import(
                        "@/views/newtheme/newcase/casedemo/demosurveyinfo.vue"
                      ),
                    meta: {
                      title1: "案件画布列表",
                      title: "案件分析报告",
                      showHeader: true,
                      showfooter: true,
                    },
                  },
                  {
                    path: "/canvaslist/createCaseanalysisReport",
                    name: "createCaseanalysisReport",
                    component: () =>
                      import("@/views/newtheme/newcase/CaseanalysisReport.vue"),
                    meta: {
                      title1: "案件画布列表",
                      title: "创建案件分析报告",
                      showHeader: true,
                      showfooter: true,
                    },
                  },
                  {
                    path: "/canvaslist/historylist",
                    name: "Historylist",
                    component: () =>
                      import("@/views/newtheme/historylist/historylist.vue"),

                    meta: {
                      title1: "案件画布列表",
                      title: "历史列表",
                      showHeader: true,
                      showfooter: true,
                    },
                  },
                  {
                    path: "/historylist/historydetail",
                    name: "Historydetail",
                    component: () =>
                      import("@/views/Analysis/canvas/history/historydetail"),
                    meta: {
                      title1: "案件画布列表",
                      title: "历史详情",
                      showHeader: true,
                      showfooter: true,
                    },
                  },
                  {
                    path: "/charactersinfo/charactersdetail",
                    name: "Charactersdetail",
                    component: () =>
                      import(
                        "@/views/newtheme/newcase/caseTab/charactersdetail.vue"
                      ),
                    meta: {
                      title1: "案件画布列表",
                      title: "人物详情",
                      showHeader: true,
                      showfooter: true,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "/home/addressanalysis",
            name: "Addressanalysis",
            component: () =>
              import("@/views/Analysis/addressAnalysis/Addressanalysis"),
            meta: {
              title1: "研判分析",
              title: "地址分析",
              showHeader: true,
              showfooter: true,
            },
            children: [
              {
                path: "/home/balanceselect",
                name: "Balanceselect",
                component: () =>
                  import("@/views/newtheme/newbalance/balancelist.vue"),
                meta: {
                  title1: "地址分析",
                  title: "余额查询",
                  showHeader: true,
                  showfooter: true,
                },
              },
              {
                path: "/home/labelselect",
                name: "Labelselect",
                component: () =>
                  import("@/views/newtheme/newlabel/labeldetail.vue"),
                // import(
                //   "@/views/Analysis/addressAnalysis/labelmanagement/Addresslabelquery.vue"
                // ),
                meta: {
                  title1: "地址分析",
                  title: "标签管理",
                  showHeader: true,
                  showfooter: true,
                },
              },
            ],
          },
          {
            path: "/home/modelanalysis",
            name: "Modelanalysis",
            component: () =>
              import("@/views/newtheme/newmodel/modelanalysis.vue"),
            meta: {
              title1: "研判分析",
              title: "AI模型",
              showHeader: true,
              showfooter: true,
            },
          },
          // {
          //   path: "/home/character",
          //   name: "Character",
          //   component: () =>
          //     import("@/views/Analysis/characteranalysis/Characteranalysis"),
          //   meta: {
          //     title1: "研判分析",
          //     title: "人物分析",
          //     showHeader: true,
          //     showfooter: true,
          //   },
          // },
          createUserDetailRoute({
            path: "/home/userdetailspage/:id",
            name: "userdetailspage",
          }),
          createUserDetailRoute({
            path: "/home/userdetails-refactor/:id",
            name: "userdetailsrefactor",
          }),
          createUserDetailRoute({
            path: "/home/wallet-user-details/:id",
            name: "walletuserdetails",
            title: "钱包用户详情",
            preferredDetailMode: "wallet",
          }),
          // {
          //   path: "/home/userdetails-refactor1/:id",
          //   name: "userdetailsrefactor2",
          //   component: () =>
          //     import(
          //       "@/views/newtheme/details/userDetailsRefactor2/userDetailMainRefactor.vue"
          //     ),
          //   meta: {
          //     title1: "研判分析",
          //     title: "用户详情（新版1）",
          //     showHeader: false,
          //     showfooter: false,
          //   },
          // },
          // {
          //   path: "/home/wallet-user-details1/:id",
          //   name: "walletuserdetails2",
          //   component: () =>
          //     import(
          //       "@/views/newtheme/details/walletUserDetails2/walletUserDetailMain.vue"
          //     ),
          //   meta: {
          //     title1: "研判分析",
          //     title: "钱包用户详情1",
          //     showHeader: false,
          //     showfooter: false,
          //   },
          // },
        ],
      },
      {
        path: "/AIcanvas",
        name: "AIcanvas",
        component: AIcanvas,
        meta: {
          title: "AI画布",
          showHeader: false,
          showfooter: false,
        },
      },
      {
        path: "/adjustment",
        name: "Adjustment",
        component: Adjustment,
        meta: {
          title: "调证管理",
          showHeader: true,
          showfooter: true,
        },
        children: [
          {
            path: "/adjustment/advise",
            name: "Advise",
            component: () =>
              import(
                "@/views/newtheme/Adjustment/recommendation/squareadvise.vue"
                // "@/views/Adjustment/squareadvise.vue"
              ),
            meta: {
              title1: "调证管理",
              title: "调证建议",
              showHeader: true,
              showfooter: true,
            },
            hidden: true,
            children: [
              {
                path: "/advise/surveydocument",
                name: "surveydocument",
                component: () =>
                  import(
                    "@/views/newtheme/Adjustment/recommendation/Documentfile.vue"
                    // "@/views/Adjustment/Surveydocument.vue"
                  ),
                meta: {
                  title1: "调证建议",
                  title: "调证文书",
                  showHeader: true,
                  showfooter: true,
                },
              },
            ],
          },

          {
            path: "/adjustment/querysuspects-list",
            name: "querysuspects-list",
            component: () =>
              import(
                "@/views/newtheme/Adjustment/UserList/querysuspectser.vue"
                // "@/views/Adjustment/querysuspectser.vue"
              ),
            meta: {
              title1: "调证管理",
              title: "调证用户",
              showHeader: true,
              showfooter: true,
            },
            hidden: true,
            children: [
              {
                path: "/querysuspects-list/surveyreport",
                name: "surveyReport",
                component: () =>
                  import(
                    "@/views/newtheme/Adjustment/UserList/surveyReport.vue"
                    // "@/views/Adjustment/Surveydocument.vue"
                  ),
                meta: {
                  title1: "调证用户",
                  title: "调证报告",
                  showHeader: true,
                  showfooter: true,
                },
              },
            ],
          },
          {
            path: "/adjustment/querysuspects-Upload",
            name: "querysuspects-Upload",
            component: () =>
              import("@/views/newtheme/Adjustment/upload/Upload.vue"),
            // import("@/views/Adjustment/Upload.vue"),
            meta: {
              title1: "调证管理",
              title: "调证上传",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/adjustment/investigation",
            name: "investigation",
            component: () =>
              import("@/views/newtheme/Adjustment/investigation/index.vue"),
            meta: {
              title1: "调证管理",
              title: "调证协查",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/adjustment/documentfilet",
            name: "documentfile",
            component: () =>
              import(
                "@/views/newtheme/Adjustment/investigation/documentfile.vue"
                // "@/views/Adjustment/Surveydocument.vue"
              ),
            meta: {
              title1: "调证协查",
              title: "文书预览",
              showHeader: true,
              showfooter: true,
            },
          },
          // {
          //   path: "/adjustment/analysis",
          //   name: "adj-analysis",
          //   component: () => import("@/views/Adjustment/adj-Analysis.vue"),
          //   meta: {
          //     title1: "调证管理",
          //     title: "调证分析",
          //   },
          //   hidden: true,
          // },
        ],
      },

      //用户中心 和修改密码
      {
        path: "/personalinfo",
        name: "Personalinfo",
        // component: () =>
        //   import("@/views/newtheme/Personalinfopage/Personalinfo.vue"),

        // 旧版用户中心：src/components/Personalinfo.vue（保留，回滚只改这一行）
        // component: () => import("@/components/Personalinfo"),
        component: () =>
          import("@/views/newtheme/newPersonalinfo/Personalinfo.vue"),
        meta: {
          title: "用户中心",
          showHeader: true,
          showfooter: true,
        },
      },
      {
        path: "/recharge-agreement",
        name: "RechargeAgreement",
        component: () =>
          import("@/views/newtheme/newPersonalinfo/RechargeAgreement.vue"),
        meta: {
          title: "积分充值及使用协议",
          showHeader: true,
          showfooter: true,
        },
      },
      {
        path: "/editpassword",
        name: "Editpassword",
        component: () => import("@/components/Editpassword"),
        meta: {
          title: "修改密码",
          showHeader: true,
          showfooter: true,
        },
      },
      {
        path: "/datacase",
        name: "Datacase",
        component: Datacase,
        meta: {
          title: "数据看板",
          showHeader: true,
          showfooter: true,
        },
        children: [
          // 产品功能介绍
          {
            path: "/datacase/researchanalysis",
            name: "researchanalysis",
            component: () => import("@/views/Analysis/AnalysisHome.vue"),
            meta: {
              title1: "数据看板",
              title: "大盘数据",
              showHeader: true,
              showfooter: false,
            },
          },
          {
            path: "/datacase/transactiondata",
            name: "transactiondata",
            // component: () => import("@/views/Datacase/newdatacase.vue"),
            component: () =>
              import("@/views/newtheme/newDatacase/caseData/datacasemain.vue"),
            meta: {
              title1: "数据看板",
              title: "交易数据",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/datacase/balancedata",
            name: "balancedata",
            component: () =>
              import(
                "@/views/newtheme/newDatacase/balanceData/balancedata.vue"
              ),
            // component: () => import("@/views/Datacase/balancedata.vue"),
            meta: {
              title1: "数据看板",
              title: "余额数据",
              showHeader: true,
              showfooter: true,
            },
          },
        ],
      },
      {
        path: "/help",
        name: "Help",
        component: Help,
        redirect: "/help/Product-function",
        meta: {
          title: "帮助中心",
          showHeader: true,
          showfooter: true,
        },
        children: [
          // 产品功能介绍
          {
            path: "/help/Product-function",
            name: "Product-function",
            component: () =>
              import("@/views/newtheme/newHelp/production-fun.vue"),
            meta: {
              title1: "帮助中心",
              title: "产品功能介绍",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/help/National-involvment",
            name: "National-involvment",
            component: () =>
              import("@/views/newtheme/newHelp/National-involvment.vue"),
            meta: {
              title1: "帮助中心",
              title: "司法判例参考",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/help/prosecuteBook",
            name: "prosecuteBook",
            component: () =>
              import("@/views/newtheme/newHelp/prosecuteBook.vue"),
            meta: {
              title1: "起诉书",
              title: "司法判例参考",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/help/judgmentBook/:value",
            name: "judgmentBook",
            component: () =>
              import("@/views/newtheme/newHelp/judgmentBook.vue"),
            meta: {
              title1: "政策法规",
              title: "司法判例参考",
              showHeader: true,
              showfooter: true,
            },
          },

          {
            path: "/help/prosecutebookDocuments",
            name: "prosecutebookDocuments",
            component: () =>
              import("@/views/newtheme/newHelp/prosecutebookDocuments.vue"),
            meta: {
              title1: "帮助中心",
              title: "起诉书参考正文",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/help/exampledetails",
            name: "exampledetails",
            component: () =>
              import("@/views/newtheme/newHelp/ReferenceDocuments.vue"),
            meta: {
              title1: "帮助中心",
              title: "司法判例参考正文",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/help/judgmentBookDocuments/:value",
            name: "judgmentBookDocuments",
            component: () =>
              import("@/views/newtheme/newHelp/judgmentBookDocuments.vue"),
            meta: {
              title1: "帮助中心",
              title: "政策法规参考正文",
              showHeader: true,
              showfooter: true,
            },
          },
        ],
      },
      // APIs（数据服务介绍）
      {
        path: "/apis",
        name: "ApiService",
        component: () => import("@/views/newtheme/newApi/ApiService.vue"),
        meta: {
          title: "APIs",
          showHeader: true,
          showfooter: false,
        },
      },
      {
        path: "/permissions",
        name: "Permissions",
        component: Permissions,
        meta: {
          title: "权限管理",
          showHeader: true,
          showfooter: true,
        },
        children: [
          // 标签管理
          {
            path: "/permissions/labelList",
            name: "labelList",
            component: () =>
              import("@/views/newtheme/newlabellist/labellist.vue"),
            // import("@/views/Permissions/label/labelList.vue"),
            meta: {
              title1: "权限管理",
              title: "标签模板列表",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/permissions/userlist",
            name: "Userlist",
            component: () => import("../views/Permissions/UserList.vue"),
            meta: {
              title1: "权限管理",
              title: "用户列表",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/permissions/tloglist",
            name: "Tloglist",
            component: () =>
              import("../views/newtheme/newtloglist/Tloglist.vue"),
            meta: {
              title1: "权限管理",
              title: "用户日志",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/permissions/adminlog",
            name: "Adminlog",
            component: () =>
              import("../views/newtheme/newtloglist/Adminlog.vue"),
            meta: {
              title1: "权限管理",
              title: "管理日志",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/permissions/feelback",
            name: "Feelback",
            component: () => import("../views/newtheme/newfeelback/Feelback"),
            meta: {
              title1: "权限管理",
              title: "用户反馈",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/permissions/roles",
            name: "Roles",
            component: () => import("../views/newtheme/newroles/Roleslist.vue"),
            meta: {
              title1: "权限管理",
              title: "角色列表",
              showHeader: true,
              showfooter: true,
            },
          },
        ],
      },
      {
        path: "/toolpage",
        name: "toolpage",
        component: Toolpage,
        meta: {
          title: "办案工具箱",
          showHeader: true,
          showfooter: true,
        },
        children: [
          // 地址查询
          {
            path: "/toolpage/caseHandlingTool",
            name: "caseHandlingTool",
            component: () =>
              import("@/views/newtheme/toolpage/caseHandlingTool.vue"),
            // import("@/views/Permissions/label/labelList.vue"),
            meta: {
              title1: "办案工具箱",
              title: "地址补全",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/toolpage/hashcompletion",
            name: "hashcompletion",
            component: () =>
              import("@/views/newtheme/toolpage/hashcompletion.vue"),
            // import("@/views/Permissions/label/labelList.vue"),
            meta: {
              title1: "办案工具箱",
              title: "哈希补全",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/toolpage/tgSentimentAnalysis",
            name: "tgSentimentAnalysis",
            component: () =>
              import("@/views/newtheme/toolpage/tgSentimentAnalysis.vue"),
            meta: {
              title1: "办案工具箱",
              title: "TG公群舆情分析",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/toolpage/tgGroupDetail/:id",
            name: "tgGroupDetail",
            component: () =>
              import("@/views/newtheme/toolpage/tgGroupDetail.vue"),
            meta: {
              title1: "办案工具箱",
              title: "TG 群组详情",
              showHeader: true,
              showfooter: true,
            },
          },
          {
            path: "/toolpage/tgUserDetail/:id",
            name: "tgUserDetail",
            component: () =>
              import("@/views/newtheme/toolpage/tgUserDetail.vue"),
            meta: {
              title1: "办案工具箱",
              title: "TG 用户详情",
              showHeader: true,
              showfooter: true,
            },
          },
        ],
      },
      {
        path: "/api",
        name: "api",
        component: API,
        meta: {
          title: "API服务",
          showHeader: true,
          showfooter: true,
        },
        children: [
          {
            path: "/api/subscription",
            name: "subscription",
            component: () =>
              import("@/views/newtheme/landing/subscription.vue"),
            meta: {
              title: "订阅计划",
              showHeader: true,
              showfooter: false,
            },
          },
          {
            path: "/api/apiServiceIntroduction",
            name: "apiServiceIntroduction",
            component: () =>
              import("@/views/newtheme/landing/apiServiceIntroduction.vue"),
            meta: {
              title: "API服务介绍",
              showHeader: true,
              showfooter: false,
            },
          },
        ],
      },
      {
        path: "/message-center",
        name: "MessageCenter",
        component: () =>
          import("@/views/newtheme/messageCenter/MessageCenter.vue"),
        meta: {
          title: "消息中心",
          showHeader: true,
          showfooter: false,
        },
      },
    ],
  },
  {
    path: "/largescreen",
    name: "largescreen",
    component: Largescreen,
    meta: {
      title: "大盘数据",
      showHeader: false,
      showfooter: false,
    },
  },

  // 未登录时的公开布局（导航栏 + router-view）
  {
    path: "/landing",
    name: "Landing",
    component: () => import("@/views/newtheme/landing/landing.vue"),
    meta: { title: "图链安全平台", showHeader: false, showfooter: false },
    redirect: "/landing/home",
    children: [
      // 首页内容
      {
        path: "home",
        name: "LandingHome",
        component: () => import("@/views/newtheme/landing/landingHome.vue"),
        meta: { title: "图链安全平台" },
      },
      // 价格方案（未登录也可看）
      {
        path: "subscription",
        name: "LandingSubscription",
        component: () => import("@/views/newtheme/landing/subscription.vue"),
        meta: { title: "订阅计划" },
      },
      {
        path: "addressdetail/:id",
        name: "Addressdetail",
        component: () =>
          import("@/views/newtheme/nologinpage/addressdetail.vue"),
        meta: { title: "地址详情" },
      },

      {
        path: "hashdetail/:id",
        name: "Hashdetail",
        component: () => import("@/views/newtheme/nologinpage/hashdetail.vue"),
        meta: { title: "哈希详情" },
      },
      {
        path: "apiServiceIntroduction",
        name: "apiServiceIntroduction",
        component: () =>
          import("@/views/newtheme/landing/apiServiceIntroduction.vue"),
        meta: { title: "API服务介绍" },
      },
    ],
  },
  {
    path: "/embed/recharge",
    name: "EmbedRecharge",
    component: () => import("@/views/newtheme/embedRecharge/EmbedRecharge.vue"),
    meta: {
      title: "积分充值",
      showHeader: false,
      showfooter: false,
    },
  },
  {
    path: "/embed/recharge/return",
    name: "EmbedRechargeReturn",
    component: () =>
      import("@/views/newtheme/embedRecharge/EmbedRechargeReturn.vue"),
    meta: {
      title: "支付返回",
      showHeader: false,
      showfooter: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/sso",
    name: "SsoAuthorize",
    component: SsoAuthorize,
  },
  {
    path: "/browser-login",
    name: "BrowserLogin",
    component: BrowserLogin,
    beforeEnter: async (to, from, next) => {
      // 简化路由守卫：只做必要的检查，具体登录逻辑交给组件处理
      // 避免路由守卫和组件重复调用 API

      // 如果已有登录态，直接跳转
      const hasExistingToken = !!window.localStorage.getItem("t_k");
      if (hasExistingToken && !isGoogleAuthPending()) {
        console.log("[路由守卫] 已有登录态，直接跳转");
        redirectAfterBrowserLogin(to, next);
        return;
      }

      // 否则进入组件让组件处理登录流程
      next();
    },
  },
  {
    //没写就是任意路由都是定向这个
    path: "",
    //重定向
    redirect: "/home",
  },

  // {
  //   path: "/home",
  //   name: "home",
  //   component: Layout,
  // },
  {
    path: "/canvasshare/:param",
    name: "canvasshare",
    component: canvasshare,
  },
];

// mode:'hash',
const router = new VueRouter({
  mode: "hash",
  routes,
});

/* 全局前置路由守卫 */
router.beforeEach((to, from, next) => {
  const rechargeReturnRoute = consumeRechargeReturnRoute();
  const restoredFromQuery = restoreAuthDataFromRouteQuery(to);
  if (restoredFromQuery) {
    console.log("[路由守卫] 已从 URL 恢复登录态");
    setNosugarSessionFlag(true);
  }

  // 判断登录状态
  // 无糖浏览器内不使用 Google Auth 2FA，跳过 isGoogleAuthPending 检查
  // 避免因残留的 gc_google_auth_pending 标记导致已登录用户被误判为未登录
  const isNosugarContext = isNosugarBrowser() || hasNosugarSessionFlag();
  let isLogin;
  if (isNosugarContext) {
    isLogin = !!window.localStorage.getItem("t_k");
  } else {
    isLogin =
      window.localStorage.getItem("t_k") && !isGoogleAuthPending()
        ? true
        : false;
  }

  if (rechargeReturnRoute) {
    if (rechargeReturnRoute.path === "/embed/recharge/return") {
      next({ ...rechargeReturnRoute, replace: true });
      return;
    }
    if (isLogin) {
      next({ ...rechargeReturnRoute, replace: true });
    } else {
      saveRedirectUrl(rechargeReturnRoute);
      next({ path: "/login", replace: true });
    }
    return;
  }

  // 登录过
  if (isLogin) {
    if (to.path === "/login") {
      next({ path: "/home", replace: true });
      return;
    }

    // console.log("我是路由");
    // console.log(to);
    // 新手引导以及画布操作
    // if (to.path == "/canvaslist/newcanvas") {
    //   let route;
    //   if (to.query.temporarilycanvas) {
    //     console.log("我是临时画布");
    //     route = "/canvaslist/newcanvas/temporarilycanvas";
    //   } else {
    //     console.log("我是正式画布");
    //     route = "/canvaslist/newcanvas";
    //   }
    //   getUserGuideData(route).then((res) => {
    //     console.log(res);
    //   });
    // }
    // 检查是否存在需要跳转的 URL
    // if (localStorage.redirectUrl) {
    //   const redirectUrl = JSON.parse(localStorage.redirectUrl);
    //   console.log("我是路由拦截器");
    //   console.log(redirectUrl);
    //   // 清除已存储的跳转 URL
    //   // localStorage.removeItem("redirectUrl");
    //   // 跳转到之前记录的页面
    //   next(redirectUrl);
    // } else {
    if (
      from.path === "/canvaslist/newcanvas" &&
      from.query.temporarilycanvas === "true" &&
      to.path !== "/canvaslist/newcanvas" &&
      to.path !== sessionStorage.topathUrl &&
      to.query.temporarilycanvas !== "true"
    ) {
      localForage.removeItem("temporariyadvancelist");
      localForage.removeItem("temporariybackStep");
      // console.log("打印-----");
      // 弹出确认框
      Vue.prototype.$showDialog(
        i18n.t("components.savedialog.exitTemporaryCanvasPrompt"),
        () => {
          // 点击「退出」（左侧按钮）：继续导航离开画布
          next();
        },
        () => {
          // 点击「保存画布」或右上角 X：留在画布，记录目标路径供下次放行
          // console.log(localStorage.canvastemporarily);
          sessionStorage.topathUrl = to.path;
          next(false);
        },
      );
      // if (window.confirm("确定要离开临时画布页面吗？")) {
      //   // 用户点击确认，继续路由导航
      //   console.log(11);

      // } else {
      //   // 用户点击取消，阻止路由导航
      //   next(false);
      // }
    } else {
      sessionStorage.topathUrl = null;
      next();
    }
    // next();

    // }
  } else {
    // 未登录时允许直接访问的白名单路径
    const publicPaths = [
      "/login",
      "/sso",
      "/browser-login",
      "/landing",
      "/forgetPassword",
      "/register",
      "/embed/recharge/return",
    ];
    const isPublic =
      publicPaths.some((p) => to.path === p || to.path.startsWith(p + "/")) ||
      to.path.startsWith("/canvasshare/") ||
      to.path.startsWith("/subscription"); // 订阅页公开可访问

    if (isPublic) {
      next();
    } else {
      if (isNosugarContext || hasAuthBootstrapQuery(to)) {
        saveRedirectUrl({
          path: to.path,
          query: { ...getQueryWithoutAuthBootstrap(to.query) },
          params: { ...to.params },
        });
        next({ path: "/browser-login", replace: true });
        return;
      }

      // 未登录访问受保护页面 → 跳转到落地页
      next({ path: "/login" });
    }
  }
});

export default router;
// 跳转后自动返回页面顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
});
